import { post } from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import { updateClinicProfile } from '../../../../../store/ai2';

interface RolePayload {
  id: string;
  role: string;
  permissions: {
    [key: string]: boolean;
  };
}

export const usePostUpdateRole = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const postUpdateRole = async (updatePayload: RolePayload[]) => {
    setIsLoading(true);
    if (!selectedTenancy) {
      return;
    }
    try {
      const payload = {
        tenancyId: selectedTenancy.tenancy_id,
        roles: updatePayload,
      };
      const { data } = await post(`updateRole`, { ...payload });
      await updateClinicProfile(dispatch);
      return data.data;
    } catch (error) {
      console.error('An error occurred during patch updateRole', error);
      setErrorMessage(
        // @ts-ignore
        error?.response?.data?.message || 'Unknown error in patch updateRole',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postUpdateRole,
    errorMessage,
    isLoading,
  };
};
